;(function() {
  'use strict'

  Controller.$inject = ["configService", "View"];
  angular.module('app.survey').component('surveyTimeMachine', {
    controller: Controller,
    templateUrl: 'survey-time-machine.html',
    bindings: {
      survey: '<',
      embedded: '<',
      view: '<',
    },
  })

  /* @ngInject */
  function Controller(configService, View) {
    var ctrl = this
    var visibleViewTypes = [
      View.Types.INTRO,
      View.Types.SECTION,
      View.Types.QUESTION,
    ]

    ctrl.$onInit = onInit
    ctrl.select = select
    ctrl.openEditor = openEditor
    ctrl.isEditVisible = isEditVisible

    function onInit() {
      ctrl.options = _.chain(ctrl.survey.views)
        .filter(function(view) {
          // exclude hidden variables
          var isVisible = _.includes(visibleViewTypes, view.type)
          var isHiddenVariables =
            view.question &&
            view.question.type === view.question.Types.HIDDEN_VARIABLES
          return isVisible && !isHiddenVariables
        })
        .map(function(view, index) {
          var label
          switch (view.type) {
            case View.Types.INTRO:
              label = 'Intro'
              break
            case View.Types.SECTION:
              label = 'Section: ' + view.section.title.slice(0, 50)
              break
            case View.Types.QUESTION:
              label = 'Q' + view.question.number + ': ' + view.question.title
              break
          }
          return {
            value: index,
            label: label,
            view: view,
          }
        })
        .value()
    }

    function isEditVisible() {
      return ctrl.view && visibleViewTypes.includes(ctrl.view.type)
    }

    function select(value) {
      var view = _.find(ctrl.options, { value: value }).view
      console.log(view)
      ctrl.survey.next(view)
    }

    function openEditor() {
      var viewParam = getViewParam(ctrl.view)

      var editUrl =
        configService.getSubscriberPortalUrl() +
        '/surveys/' +
        ctrl.survey.id +
        '?tab=editor&view=' +
        viewParam

      window.open(editUrl, '_blank')
    }

    function getViewParam(view) {
      switch (view.type) {
        case View.Types.INTRO:
          return 'intro'

        case View.Types.QUESTION:
          return 'q' + view.question.number

        case View.Types.SECTION:
          return 's' + view.section.number
      }
    }
  }
})()
